import { LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutTieredStopCharge } from "./autogen/AutogenLayoutTieredStopCharge";

export class TieredStopCharge extends AutogenLayoutTieredStopCharge {
    textboxChargeCodeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const chargeCode = event.selection;
            this.activeRow?.set("descr", chargeCode.getString("descr"));
        }
    }
}